import Alpine, { type AlpineComponent } from "alpinejs";

type WarrantyYear = number;
type WarrantyBrand = string | null;

interface WarrantyBookletAlpine {
    activeYearArray: WarrantyYear[];
    activeBrand: WarrantyBrand;
    placeholder: string | null;
    isVisible(el: HTMLElement): boolean;
    filterByBrand(brand: WarrantyBrand): void;
    listingFiltering(item: WarrantyYear): void;
    updatePlaceholder(array: WarrantyYear[]): void;
}

type WarrantyBookletComponent = AlpineComponent<WarrantyBookletAlpine>;

const parseYears = (value: string | undefined): WarrantyYear[] => {
    if (!value) {
        return [];
    }

    const years = JSON.parse(value) as unknown;

    return Array.isArray(years)
        ? years.filter((year): year is WarrantyYear => Number.isInteger(year))
        : [];
};

document.addEventListener('alpine:init', () => {
    Alpine.data('initCarnetGarantie', (): WarrantyBookletComponent => {
        return {
            activeYearArray: [],
            activeBrand: null,
            placeholder: null,
            isVisible(el: HTMLElement): boolean {
                const brand = el.dataset.brand ?? null
                const years = parseYears(el.dataset.years)
                const yearMatch = this.activeYearArray.length === 0
                    || this.activeYearArray.some(y => years.includes(y))
                const brandMatch = this.activeBrand === null || brand === this.activeBrand
                return yearMatch && brandMatch
            },
            filterByBrand(brand: WarrantyBrand) {
                this.activeBrand = this.activeBrand === brand ? null : brand
            },
            listingFiltering(item: WarrantyYear) {
                const index = this.activeYearArray.indexOf(item)
                if (index > -1) {
                    this.activeYearArray.splice(index, 1)
                } else {
                    this.activeYearArray.push(item)
                }
                this.updatePlaceholder(this.activeYearArray)
            },
            updatePlaceholder(array: WarrantyYear[]) {
                this.placeholder = array.length > 0 ? array.join(', ') : null
            }
        }
    })
})
